import { Text } from './TextConstants'

export const OrangeColor = '#de411b'
export const ErrorColor = '#ff0000'
export const GrayColor = '#aeaaaa'
export const GrayLight = '#a9a9a9'
export const GrayDark = '#536067'
export const BlueLight = '#359EFF'
export const TextGrayColor = '#667080'
export const backgroundDocument = '#f0f3f3'
export const backgroundSelected = '#ffffff'
export const textSelected = '#40a9ff'
export const GrayLightBorder = '#d9d9d9'
export const White = '#ffffff'
export const DBSkills = 'databases'
export const Domains = 'domains'
export const programmingLanguages = 'programming_languages'
export const FrameworksAndTechnologies = 'technologies_and_frameworks'
export const SoftSkills = 'soft_skills'
export const TechnicalSkills = 'technical_skills'
export const Hobbies = 'hobbies'
export const IndustrySector = 'industry_sector'
export const EducationGrades = 'education_grades'
export const CertificationEntity = 'certification_entity'
export const testing = 'testing_and_development_tools'
export const LanguagesSkills = 'languages'
export const pdfEndPoint = process.env.REACT_APP_EXPORT_DATA

const FILTER_OPTION_CODES = {
  coreSkill: { name: 'Core Skills', value: 'coreSkill' },
  discipline: { name: 'Discipline', value: 'discipline' },
  du: { name: 'DL', value: 'DU' },
  grade: { name: 'Grade', value: 'grade' },
  role: { name: 'Role', value: 'role' },
  userRole: { name: 'User Role', value: 'userRole' },
  completion: { name: `% ${Text.Completion}`, value: Text.Completion.toLowerCase() }
}

export const USER_LIST_FILTER_OPTIONS = [
  FILTER_OPTION_CODES.coreSkill,
  FILTER_OPTION_CODES.discipline,
  FILTER_OPTION_CODES.du,
  FILTER_OPTION_CODES.grade,
  FILTER_OPTION_CODES.role,
  FILTER_OPTION_CODES.completion
]

export const ROLES = {
  admin: 'Admin',
  endavan: 'Endavan',
  manager: 'Manager',
  headOfDiscipline: 'Head Of Discipline',
  lead: 'Lead'
}

export const TEMPLATE_SECTIONS_THRESHOLD = {
  languages: 5,
  programmingLanguages: 7,
  databases: 4,
  technologies: 7,
  hobbies: 5,
  technicalSkills: 7,
  professionalExperience: 5,
  educationalBackground: 3,
  certifications: 5,
  industryVerticals: 5
}

export const TOOLTIP_TEXT = {
  itemNotFound: 'Item not found. To add a new one, contact your local discipline leads.'
}
